<template>
  <div class="row">
    <div class="flex md2">
      <va-button
        class="fullwidth"
        :outline="opambColor === 'gray'"
        small
        :color="opambColor"
        @click="changeAdhesion(opambId, 2)"
      >OPAM-B</va-button>
    </div>
    <div class="flex md2">
      <va-button
        class="fullwidth"
        :outline="agromerColor === 'gray'"
        small
        :color="agromerColor"
        @click="changeAdhesion(agromerId, 3)"
      >AGROMER</va-button>
    </div>
    <div class="flex md2">
      <va-button
        class="fullwidth"
        :outline="scappColor === 'gray'"
        small
        :color="scappColor"
        @click="changeAdhesion(scappId, 1)"
      >SCAPP</va-button>
    </div>
    <div class="flex md2">
      <va-button
        class="fullwidth"
        :outline="federationLRColor === 'gray'"
        small
        :color="federationLRColor"
        @click="changeAdhesion(federationLRId, 6)"
      >Féd. LR</va-button>
    </div>
    <div class="flex md2">
      <va-button
        class="fullwidth"
        :outline="federationVColor === 'gray'"
        small
        :color="federationVColor"
        @click="changeAdhesion(federationVId, 4)"
      >Féd. Vendée</va-button>
    </div>
    <div class="flex md2">
      <va-button
        class="fullwidth"
        :outline="sdepColor === 'gray'"
        small
        :color="sdepColor"
        @click="changeAdhesion(sdepId, 7)"
      >S.D.E.P.</va-button>
    </div>
    <autres-adhesions-manager
      v-model="openManager"
      :idadhesion="idadhesion"
      :adhesiontype="adhesiontype"
      :identreprise="identreprise"
      v-on:ok="loadAdhesions(identreprise)"
    ></autres-adhesions-manager>
  </div>
</template>

<script>
import axios from "axios";
import autresAdhesionsManager from "./AutresAdhesionsManager";

export default {
  name: "autresAdhesion",
  props: ["identreprise"],
  components: { autresAdhesionsManager },
  data() {
    return {
      idadhesion: null,
      opambId: null,
      scappId: null,
      agromerId: null,
      federationLRId: null,
      sdepId: null,
      federationVId: null,
      opambColor: "gray",
      scappColor: "gray",
      agromerColor: "gray",
      federationLRColor: "gray",
      federationVColor: "gray",
      sdepColor: "gray",

      openManager: false,
      adhesiontype: null
    };
  },
  computed: {},
  watch: {
    identreprise: {
      immediate: true,
      handler(newid) {
        if (newid) {
          this.loadAdhesions(newid);
        }
      }
    }
  },
  methods: {
    async loadAdhesions(identreprise) {
      try {
        let adhesionList = await axios.get("/api/autres-adhesions/get-status", {
          params: {
            identreprise: identreprise
          }
        });

        this.opambId = adhesionList.data.opambId
          ? adhesionList.data.opambId
          : null;
        this.scappId = adhesionList.data.scappId
          ? adhesionList.data.scappId
          : null;
        this.agromerId = adhesionList.data.agromerId
          ? adhesionList.data.agromerId
          : null;
        this.federationLRId = adhesionList.data.federationLRId
          ? adhesionList.data.federationLRId
          : null;
        this.federationVId = adhesionList.data.federationVId
          ? adhesionList.data.federationVId
          : null;
        this.sdepId = adhesionList.data.sdepId
          ? adhesionList.data.sdepId
          : null;

        if (
          this.opambId ||
          this.scappId ||
          this.agromerId ||
          this.federationLRId ||
          this.federationVId ||
          this.sdepId
        ) {
          this.$emit("opefStatutsTierce", "success");
        } else {
          this.$emit("opefStatutsTierce", "");
        }
        console.log('data', adhesionList.data)
        this.opambColor = adhesionList.data.opamb ? "info" : "gray";
        this.scappColor = adhesionList.data.scapp ? "danger" : "gray";
        this.agromerColor = adhesionList.data.agromer ? "warning" : "gray";
        this.federationLRColor = adhesionList.data.federationLR
          ? "dark"
          : "gray";
        this.federationVColor = adhesionList.data.federationV ? "dark" : "gray";
        this.sdepColor = adhesionList.data.sdep ? "dark" : "gray";
      } catch (error) {
        this.launchEpicmaxToast("Erreur lors de la lecture des adhesions");
      }
    },
    changeAdhesion(idadhesion, idtype) {
      this.idadhesion = idadhesion;
      this.adhesiontype = idtype;
      this.openManager = true;
    },
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000
      });
    }
  }
};
</script>

<style lang="scss">
.custom-button {
  width: 95%;
  border-color: #40e583;
  border-width: 2px;
  border-style: solid;
}
</style>
